import React from 'react';

import * as AppConstants from '../../../app/AppConstants';
import { Button, Dialog, DialogTitle, DialogContent, Grid } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AccessibilityNewSharpIcon from '@mui/icons-material/AccessibilityNewSharp';

function ManagePaymentDialog(props) {
  const isOpen = props.isOpen;
  const currentPaymentMethod = props.currentPaymentMethod;

  const paymentMethodButtons = [
    {
      title: (currentPaymentMethod !== AppConstants.APPLICATION_PAYMENT_METHOD.OLPP.ID
        ? 'Change' : 'Proceed') + ' to ' + AppConstants.APPLICATION_PAYMENT_METHOD.OLPP.NAME,
      icon: OpenInNewIcon,
      iconsize: 21,
      action: () => props.handlePaymentMethodClicked(AppConstants.APPLICATION_PAYMENT_METHOD.OLPP.ID),
      visible: true,
    },
    // {
    //   title: (currentPaymentMethod !== AppConstants.APPLICATION_PAYMENT_METHOD.CCP.ID
    //     ? 'Change' : 'Proceed') + ' to ' + AppConstants.APPLICATION_PAYMENT_METHOD.CCP.NAME,
    //   icon: OpenInNewIcon,
    //   iconsize: 21,
    //   action: () => props.handlePaymentMethodClicked(AppConstants.APPLICATION_PAYMENT_METHOD.CCP.ID),
    //   visible: true,
    // },
    {
      title: 'Change to ' + AppConstants.APPLICATION_PAYMENT_METHOD.INPERSON.NAME,
      icon: AccessibilityNewSharpIcon,
      iconsize: 25,
      action: () => props.handlePaymentMethodClicked(AppConstants.APPLICATION_PAYMENT_METHOD.INPERSON.ID),
      visible: currentPaymentMethod !== AppConstants.APPLICATION_PAYMENT_METHOD.INPERSON.ID,
    },
  ]

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      onClose={!!props.onClose ? props.onClose : null}
    >
      <DialogTitle id="alert-dialog-title">
        Manage Payment
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} style={{width: 280}}>
          {
            paymentMethodButtons.map((button, i) => (
              button.visible
              && <Grid key={i} item xs={12}>
                <Button variant='contained'
                  style={{paddingLeft: 20, fontSize: 13, width: '100%', height: 80, lineHeight: 1.5}}
                  onClick={button.action}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={10}>
                      {button.title}
                    </Grid>
                    <Grid item xs={2} 
                      style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                    >
                      <button.icon style={{fontSize: button.iconsize}} />
                    </Grid>
                  </Grid>
                </Button>
              </Grid>
            ))
          }
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default ManagePaymentDialog;
